function httpStatusReducer(currentState = [], action) {
  switch (action.type) {
    case "SET_STATUS":
        return action.payload.status;
    default:
      break;
  }
  return currentState;
}

export default httpStatusReducer;
